import React, { useEffect, useState } from 'react'
import TablaQuirofanosReprogramar from './TablaQuirofanosReprogramar'
import Loading from '../../Loading'
import { postCirugiaQuirofano } from '../../../services/PaginaRuta';

const ModalQuirofanosReprogramar = ({setmodalOnQuirofanos,passDataQuirofano}) => {
    const [loading, setLoading] = useState(false);
    const [dataQuirofano, setDataQuirofano] = useState([]);
    const handleCancelarClick=()=>{
        setmodalOnQuirofanos(false)
    }

    useEffect(()=>{
        postCirugiaQuirofano().then((res)=>{
            setLoading(true);
            console.log(res.data,'dataa quirofanos')
            setDataQuirofano(res.data)
        })
    },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Lista de Selección Salas de Cirugía
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
           
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-4 inline-block min-w-full sm:px-6 ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center">
                      <thead className="border-b bg-gray-200">
                        <tr>
                        <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Código
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Descripción
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          dataQuirofano.map((item, index) => (
                            <TablaQuirofanosReprogramar
                              item={item}
                              key={index}
                              passDataQuirofano={passDataQuirofano}
                            />
                          ))
                        ) : (
                          <tr>
                            <td></td>
                            <td >
                              
                            </td>
                            <td className="text-left">
                              <Loading /> 
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            {/* <button type="button"
              className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
              Guardar
            </button> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalQuirofanosReprogramar